import { useState, forwardRef } from 'react';
import { BiSearch } from 'react-icons/bi';
import { useDebouncedCallback } from 'use-debounce';
import { Box, Checkbox, Typography } from '@mui/material';
import { kollectAITheme } from 'config/theme';
import useStyles from './index.styles';

interface Props {
  data: Array<Record<string, any>>;
  headers: Array<string>;
  onHeaderSelect: (checked: boolean, header: Record<string, any>) => void;
}

const LogsHeaderSelector = forwardRef<HTMLDivElement, Props>(
  function LogsHeaderSelector({ data, headers, onHeaderSelect }, ref) {
    const classes = useStyles();

    const [headerData, setHeaderData] =
      useState<Array<Record<string, any>>>(data);
    const [searchValue, setSearchValue] = useState<string>('');

    const debounced = useDebouncedCallback((value) => {
      let filteredData = data.filter((item: Record<string, any>) =>
        item.name.toLowerCase().includes(value.toLowerCase())
      );
      setSearchValue(value);
      setHeaderData(filteredData);
    }, 0);

    return (
      <Box className={classes.headerSelectorCont} ref={ref}>
        <Box className={classes.headerSelectorSearch}>
          <input
            type='text'
            placeholder='Search'
            value={searchValue}
            onChange={(e) => debounced(e.target.value)}
          />
          <BiSearch size={20} />
        </Box>
        <Box className={classes.headersDataList}>
          {headerData.length ? (
            headerData?.map((data) => (
              <Box key={data.key} className={classes.headersDataItem}>
                <Checkbox
                  size='small'
                  checked={headers.includes(data.name)}
                  onChange={(e) => onHeaderSelect(e.target.checked, data)}
                  inputProps={{ 'aria-label': 'select header' }}
                  sx={{
                    padding: '10px',
                    color: kollectAITheme.primaryColor,
                    '&.Mui-checked': {
                      color: kollectAITheme.primaryColor,
                    },
                  }}
                />
                <Typography fontSize='0.8rem'>{data.name}</Typography>
              </Box>
            ))
          ) : (
            <Box className={classes.headersNoData}>
              <Typography fontSize='0.8rem' color='gray'>
                No data found
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    );
  }
);

export default LogsHeaderSelector;
